// The unit bases each side of a link reads in — a contract has no tracking unit.
import {
  createUnitTypeOptions,
  WORKING_DECLARATION_LABEL_KEYS,
  UNIT_TYPES,
} from '@/config/unitTypes.constants';

export const contractUnits = createUnitTypeOptions(WORKING_DECLARATION_LABEL_KEYS);

export const shipmentUnits = createUnitTypeOptions({
  ...WORKING_DECLARATION_LABEL_KEYS,
  [UNIT_TYPES.tracking]: 'UNIT_TRACKING',
});

// An outgoing shipment's orders carry no tracking unit either.
export const orderUnits = createUnitTypeOptions(WORKING_DECLARATION_LABEL_KEYS);
